/* eslint-disable react/no-children-prop */
import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import RecipeDialog from "./RecipeDialog";
import { RecipeDetailsContent } from "./components";
import RecipeFloatingActions from "./components/RecipeFloatingActions";
import useRecipeDetails from "./hooks/useRecipeDetails";

/**
 * RecipeDetails component displays detailed information about a recipe
 * including name, description, ingredients, instructions, and image.
 *
 * @param {Object} recipe - The recipe object to display
 * @param {Function} uploadImage - Function to handle image uploads
 */
const RecipeDetails = ({ recipe, organizationId, uploadImage }) => {
  console.log("RecipeDetails recipe", recipe, organizationId);

  if (!recipe) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flex={1}
        p={4}
      >
        <CircularProgress />
        <Typography variant="body1" sx={{ ml: 2 }}>
          Loading recipe...
        </Typography>
      </Box>
    );
  }

  const {
    showDialog,
    selectedRecipe,
    editIngredient,
    handleEditClick,
    handleImageUpload,
    handleDialogClose,
  } = useRecipeDetails(recipe, organizationId, uploadImage);

  return (
    <Box sx={{ pb: 10 }}>
      <RecipeDetailsContent
        recipe={recipe}
        onEditClick={handleEditClick}
        onImageUpload={handleImageUpload}
      />

      <RecipeFloatingActions recipe={recipe} />

      <RecipeDialog
        open={showDialog}
        recipe={selectedRecipe}
        editIngredient={editIngredient}
        onClose={handleDialogClose}
      />
    </Box>
  );
};

export default RecipeDetails;
